//  Dashboard.js
//
//  Updated 3/4.
//
//  Abstract: Main dashboard template page.

//	React
import React, { useState, useEffect } from 'react';
import { authMiddleware } from '../../services/auth/auth.js'
import { useHistory } from "react-router-dom";
import useFetch from '../../hooks/useFetch.js';
//	Components
import ContentContainer from '../Dashboard/__common__/ContentContainer/ContentContainer.js';
import NavigationBar from '../Dashboard/__common__/NavigationBar/NavigationBar.js';
import SideBar from '../Dashboard/__common__/SideBar/SideBar.js';
//
import Overview from './Overview/Overview.js';
import CreateTests from './CreateTests/CreateTests';
import ViewTests from './ViewTests/ViewTests';
import ReviewTests from './ReviewTests/ReviewTests.js';
import AccountConfiguration from './AccountConfiguration/AccountConfiguration.js';
import NotFound from '../NotFound/NotFound.js';
//	Material
import { makeStyles, CircularProgress } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
}))
export default function Dashboard(props) {

	// const classes = useStyles();
	const history = useHistory();
	const classes = useStyles();

	const { get } = useFetch();

		//	Define state
		const [firstName, setFirstName] = useState('');
		const [lastName, setLastName] = useState('');
		const [email, setEmail] = useState('');
		const [organization, setOrganization] = useState('');
		const [isUiLoading, setIsUiLoading] = useState(true);
		const [componentToRender, setComponentToRender] = useState('Overview');
		const [errors, setErrors] = useState([]);
		const [anchorEl, setAnchorEl] = useState(null);



	//	On component mount
	useEffect(() => {
		authMiddleware(history);
		const authToken = localStorage.getItem('AuthToken');
		get('/user', authToken)
			.then(data => {
				if (data) {
					setFirstName(data.userCredentials.firstName);
					setLastName(data.userCredentials.lastName);
					setEmail(data.userCredentials.email);
					setOrganization(data.userCredentials.organization);
					setIsUiLoading(false);
					console.log(data.userCredentials)
				} else {
					// Request error
					console.log(data);
					setErrors(data);
				}
			})
			.catch(errors => {
				//	Forbidden
				if (errors.status === 403) {
					history.push('/login')
				}
				console.log(errors);
				setErrors(['Error in retrieving account data.']);
				history.push('/login')
			});
	}, []);

	//	On component loading
	if (isUiLoading) {
		return (
			<div className={classes.root}>
				{isUiLoading && <CircularProgress size={40} color="tertiary" className={classes.uiProgess} />}
			</div>
		);
	} else {
		return (
			<div className={classes.root}>
				{/* <CssBaseline /> */}
				<NavigationBar />
				<SideBar />
				<ContentContainer>
					<Switch>
						<Route exact path='/create'>
							<CreateTests />
						</Route>
						<Route exact path='/view'>
							<ViewTests />
						</Route>
						<Route exact path='/review'>
							<ReviewTests />
						</Route>
						<Route exact path='/'>
							<Overview />
						</Route>
						<Route>
							<NotFound />
						</Route>
					</Switch>
				</ContentContainer>
			</div>
		);
	}
}
